import {
  getEvisearchSuggestions,
  MAX_SUGGESTIONS_PAGE_SIZE,
} from '~/api/suggestions/evisearchSuggestionsSource';
import { JsonApiListResponse } from '~/redux/api/ApiTypes';
import { SearchFilterApiResponse } from '~/redux/api/evisearch/searchTypes';
import { pilot, eviSearch } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

const CONTRACT_TYPE_LABEL = 'Contract Type';

interface Request {
  clientId: PilotId;
}

interface Response {
  suggestions: string[];
}

const resolveContractTypeFilterId = async (): Promise<string | undefined> => {
  // Override user locale to retrieve consistent label value for the "Contract Type" filter,
  // so that it can be used to match the correct filter ID in the response regardless of the user's locale setting.
  const response: JsonApiListResponse<'filter', SearchFilterApiResponse> =
    await eviSearch.get('/filters', {
      params: { entity: 'document' },
      headers: { 'Accept-Language': 'en' },
    });
  const filter = response.data.find(
    (f) => f.attributes.label === CONTRACT_TYPE_LABEL,
  );
  return filter?.id;
};

export const getClientContractTypes = async ({
  clientId,
}: Request): Promise<string[]> => {
  const filterId = await resolveContractTypeFilterId();
  if (filterId) {
    const response = await getEvisearchSuggestions(
      filterId,
      'document',
      '',
      MAX_SUGGESTIONS_PAGE_SIZE,
    );
    return response.values.map((v) => String(v.display_value || v.value));
  }

  const response: Response = await pilot.get(
    `client/${clientId}/contract-types/`,
  );

  return response.suggestions;
};
